import React from 'react'

import PropTypes from 'prop-types'
import {
    Box,
    Flex,
    Text,
    useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {InfoIcon} from '../icons'
import InfoPopover from '../popovers/info-popover'

const BenefitCard = ({icon, strongText, normalText, infoPopoverTitle, infoPopoverDescription}) => {
    const styles = useMultiStyleConfig('BenefitCard')

    return (
        <Box {...styles.card}>
            {icon}
            <Flex {...styles.textContainter}>
                <Text {...styles.strongText}>{strongText}</Text>
                {strongText && normalText && <Text>&nbsp;</Text>}
                <Text {...styles.normalText}>{normalText}</Text>
            </Flex>
            <Box {...styles.infoPopBox}>
                <InfoPopover
                    variant="left-center"
                    trigger={<InfoIcon {...styles.infoIcon} aria-label="More Info" />}
                    openTooltipOn="hover"
                    title={infoPopoverTitle}
                    description={infoPopoverDescription}
                />
            </Box>
        </Box>
    )
}

BenefitCard.propTypes = {
    icon: PropTypes.node,
    children: PropTypes.node,
    infoPopoverTitle: PropTypes.string,
    infoPopoverDescription: PropTypes.string,
    strongText: PropTypes.node,
    normalText: PropTypes.node,
}

export default BenefitCard
